(() => {
  const guest = document.querySelector('[data-spider-guest]');
  if (!guest) return;
  let count = 0, timer, hideTimer, stopped = false;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const art = guest.querySelector('.spider-art');
  let drag = null;
  try { if (sessionStorage.getItem('psn-spider-dismissed')) return; } catch {}
  const clamp = (value, min, max) => Math.min(Math.max(value, min), Math.max(min, max));
  const place = (left, top) => {
    guest.style.left = `${clamp(left, 8, innerWidth - guest.offsetWidth - 8)}px`;
    guest.style.top = `${clamp(top, 8, innerHeight - guest.offsetHeight - 8)}px`;
    guest.style.right = 'auto'; guest.style.bottom = 'auto';
  };
  const restorePosition = () => {
    try { const saved = JSON.parse(sessionStorage.getItem('psn-mascot-position')); if (saved) place(saved.left, saved.top); } catch {}
  };
  const schedule = delay => { clearTimeout(timer); if (!stopped) timer = setTimeout(show, delay); };
  const busy = () => document.hidden || document.querySelector('dialog[open]') || document.activeElement?.matches('input,textarea,select');
  const hide = () => {
    if (guest.matches(':hover') || guest.contains(document.activeElement)) { hideTimer = setTimeout(hide, 4000); return; }
    guest.hidden = true;
    if (count < 3) schedule(75000);
  };
  const show = () => {
    if (busy()) { schedule(10000); return; }
    guest.classList.toggle('spider-left', count % 2 === 1);
    guest.hidden = false;
    restorePosition();
    count++;
    hideTimer = setTimeout(hide, 14000);
  };
  guest.querySelector('.spider-close').addEventListener('click', () => {
    stopped = true; clearTimeout(timer); clearTimeout(hideTimer); guest.hidden = true;
    try { sessionStorage.setItem('psn-spider-dismissed', '1'); } catch {}
  });
  art.style.touchAction = 'none';
  art.addEventListener('pointerdown', event => {
    if (event.button !== 0) return;
    const rect = guest.getBoundingClientRect();
    drag = { x:event.clientX, y:event.clientY, left:rect.left, top:rect.top };
    art.setPointerCapture(event.pointerId);
    guest.classList.add('is-dragging');
  });
  art.addEventListener('pointermove', event => {
    if (!drag) return;
    event.preventDefault();
    place(drag.left + event.clientX - drag.x, drag.top + event.clientY - drag.y);
  });
  const endDrag = event => {
    if (!drag) return;
    drag = null; guest.classList.remove('is-dragging');
    if (art.hasPointerCapture(event.pointerId)) art.releasePointerCapture(event.pointerId);
    const rect = guest.getBoundingClientRect();
    try { sessionStorage.setItem('psn-mascot-position', JSON.stringify({left:rect.left,top:rect.top})); } catch {}
  };
  art.addEventListener('pointerup', endDrag);
  art.addEventListener('pointercancel', endDrag);
  art.addEventListener('click', () => {
    if (reduced) return;
    art.animate([{transform:'rotateY(0) scale(1)'},{transform:'rotateY(-18deg) rotateZ(-5deg) scale(1.06)'},{transform:'rotateY(0) scale(1)'}],{duration:650,easing:'ease-out'});
  });
  art.addEventListener('pointermove', e => {
    if (reduced || e.pointerType !== 'mouse') return;
    const r=art.getBoundingClientRect();
    art.style.transform='rotateY('+((e.clientX-r.left)/r.width-.5)*16+'deg) rotateX('+(.5-(e.clientY-r.top)/r.height)*12+'deg)';
  });
  art.addEventListener('pointerleave', () => art.style.transform='');
  window.addEventListener('pagehide', () => {stopped=true;clearTimeout(timer);clearTimeout(hideTimer);});
  schedule(5000);
})();
